export const envVars = {
  local: {
    apiUri: 'http://localhost:8080',
    apikey: 'dvLlRw0YLZH3G6EZrARDzIYsl7vduxfaBxFCEz2jh7BWOoNt'
  },
  dev: {
    apiUri: 'https://dev-api.ascension.org/associate-response',
    apikey: 'dvLlRw0YLZH3G6EZrARDzIYsl7vduxfaBxFCEz2jh7BWOoNt'
  },
  qa: {
    apiUri: 'https://test-api.ascension.org/associate-response',
    apikey: 'dvLlRw0YLZH3G6EZrARDzIYsl7vduxfaBxFCEz2jh7BWOoNt'
  },
  uat: {
    apiUri: 'https://uat-api.ascension.org/associate-response',
    apikey: 'dvLlRw0YLZH3G6EZrARDzIYsl7vduxfaBxFCEz2jh7BWOoNt'
  },
  prod: {
    apiUri: 'https://prod-api.ascension.org/associate-response',
    apikey: 'S9Kh3mGJeG89DVfB9z985WXyJJCttsrVLDLaKtkNzhyuk1jG'
  }
};

export const getEnvVars = host => {
  /*console.log('checking for host');
  if (host === 'daily-covid-response-ui-qa.pub.cloud-02.pcf.ascension.org') {
    console.log(host);
    // Immediate redirect to new URL
    const newUrl = 'https://dscas.pub.qa.at-npd.ascension.org/daily-covid-response-ui' + window.location.pathname + window.location.search;
    console.log(newUrl);
    window.location.replace(newUrl); 
    return envVars.qa; 
  }else{
    console.log('host not matched');
  }*/

  switch (host) {
    case 'localhost:3000':
      return envVars.local;

    case 'dscas.pub.dev.at-npd.ascension.org':
    case 'daily-covid-response-ui-dev.pub.cloud-01.pcf.ascension.org':
      return envVars.dev;

    case 'dscas.pub.qa.at-npd.ascension.org':
    case 'daily-covid-response-ui-qa.pub.cloud-02.pcf.ascension.org':
      return envVars.qa;

    case 'dscas.pub.uat.at-ppd.ascension.org':
    case 'daily-covid-response-ui-uat.pub.cloud-02.pcf.ascension.org':
      return envVars.uat;

    case 'dscas.pub.at.ascension.org':
    case 'daily-covid-response-ui.pub.cloud-03.pcf.ascension.org':
      return envVars.prod;

    default:
      return {};
  }
};
